import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import isArray from 'lodash/isArray';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

interface AlertDialogProps {
  handleAccept: () => void;
  handleCancel: () => void;
  open: boolean;
  text: string | string[];
  title?: string;
}

const AlertDialog: FC<AlertDialogProps> = ({ handleAccept, handleCancel, open, title, text }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {isArray(text) ? (
            <>
              {text.map((line, index) => (
                <div key={`alert_text_${index}`}>{line}</div>
              ))}
            </>
          ) : (
            <>{text}</>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="secondary">
          {t('label.cancel')}
        </Button>
        <Button onClick={handleAccept} color="primary" autoFocus>
          {t('label.continue')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { AlertDialog };
